import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hasRulesIndicator: {
		id: 'accessible-workflow-diagram.common.rules-indicator.has-rules-indicator',
		defaultMessage: 'Has {rulesCount, plural, one {# rule} other {# rules}}.',
		description: 'Indicates that a transition has rules',
	},
});
